export const formatPrice = (value) => {
    value = value?.toString();
    var lastThree = value?.substring(value?.length - 3);
    var otherNumbers = value?.substring(0, value?.length - 3);
    if (otherNumbers != '')
        lastThree = ',' + lastThree;
    var res = otherNumbers?.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    const formatted = `₹${res}`
    return formatted
}